import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { visibility } from "../../redux/slices/rightSideAd";
import Loader from "../../components/Loader/Loader";
import {
  SCHOOL_ADMIN,
  STUDENT_ROLE,
  TEACHER_ROLE,
} from "../../utils/constants";
import images from "../../assets/images";
import { useNavigate } from "react-router-dom";
import axios, { AxiosResponse } from "axios";
import './HelpCenter.scss';
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import { getScreenDimensions } from "../../utils/helper";

const HelpCenter = () => {
  const dispatch = useAppDispatch();
  dispatch(visibility({ isVisible: false }));
  const { backArrow } = images;
  const navigate = useNavigate();
  const role = useAppSelector((state) => state.auth.role);
  const [loading, setLoading] = useState<boolean>(false);
  const katonCms = process.env.REACT_APP_KATON_CMS_SITE;
  const [content, setContent] = useState();
  const [data, setData] = useState("");
  const {isMobileScreen} = getScreenDimensions();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response: AxiosResponse = await axios.get(
          `${katonCms}/classroom_help`,
          {
            headers: {
              "X-Hash-Key": process.env.REACT_APP_KATON_SITE_API_KEY,
            },
          }
        );
        const contentIs = response.data;
        setContent(contentIs);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false); // Stop the loader
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (content) {
      setData(content[0]["Content"]);
    }
  }, [content]);

  return (
    <div className="HelpOptionCtn" style={{
     paddingLeft: (role === TEACHER_ROLE ||role === STUDENT_ROLE ) && !isMobileScreen  ? '70px' : undefined
    }}>
      <div className="helpCenterTopHeader">
        <div className="TermsAndPrivacyPolicyHeader">
          <img
            src={backArrow}
            alt="backButton"
            className="TermsAndPrivacyPolicyBackBtn"
            onClick={() =>
              navigate(
                role === SCHOOL_ADMIN
                  ? "/admin-help"
                  : role === TEACHER_ROLE
                  ? "/teacher-help"
                  : role === STUDENT_ROLE
                  ? "/student-help"
                  : ""
              )
            }
            style={{
              position: "relative",
              right: "45px",
            }}
          />
          <h1
            className="TermsAndPrivacyPolicyHeading"
            style={{
              position: "relative",
              right: "50px",
            }}
          >
            Help
          </h1>
        </div>
       {getScreenDimensions()?.isMobileScreen && <MobileHeader/>}
      </div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div
            className="help-content"
            dangerouslySetInnerHTML={{ __html: data }}
          ></div>
        </>
      )}
    </div>
  );
};

export default HelpCenter;
